import script from "./on-site-system-tip-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./on-site-system-tip-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./on-site-system-tip-dialog.vue?vue&type=style&index=0&id=57c6ca94&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c6ca94"]])

export default __exports__